var React = require('react');

function Notification (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","fill":"currentColor","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M8.53711 9.96484H7.34766L6.99219 3.00586H8.88574L8.53711 9.96484ZM6.91016 12.1455C6.91016 11.8083 6.99902 11.5531 7.17676 11.3799C7.35449 11.2021 7.60742 11.1133 7.93555 11.1133C8.25911 11.1133 8.50749 11.2044 8.68066 11.3867C8.85384 11.569 8.94043 11.8219 8.94043 12.1455C8.94043 12.4691 8.85156 12.7266 8.67383 12.918C8.50065 13.1048 8.25456 13.1982 7.93555 13.1982C7.61198 13.1982 7.35905 13.1071 7.17676 12.9248C6.99902 12.7425 6.91016 12.4827 6.91016 12.1455Z","fill":"white","key":1})]);
}

Notification.defaultProps = {"viewBox":"0 0 16 16","fill":"none","style":{"color":"#F6BE5A"}};

module.exports = Notification;

Notification.default = Notification;
